const BASE_PATH = "/assets";

export const GAME_SOUNDS = {
  sounds: [
    {
      name: "backgroundMusic",
      url: `${BASE_PATH}/sounds/backgroundMusic.mp3`,
      loop: true,
      volume: 0.1,
    },
    {
      name: "smallWin",
      url: `${BASE_PATH}/sounds/smallWin.mp3`,
      volume: 0.1,
    },
    {
      name: "normalWin",
      url: `${BASE_PATH}/sounds/normalWin.mp3`,
      volume: 0.2,
    },
    {
      name: "mediumWin",
      url: `${BASE_PATH}/sounds/mediumWin.mp3`,
      volume: 0.2,
    },
    {
      name: "bigWin",
      url: `${BASE_PATH}/sounds/bigWin.mp3`,
      volume: 0.2,
    },
    {
      name: "megaWin",
      url: `${BASE_PATH}/sounds/megaWin.mp3`,
      volume: 0.2,
    },
    {
      name: "superWin",
      url: `${BASE_PATH}/sounds/superWin.mp3`,
      volume: 0.2,
    },
    {
      name: "click",
      url: `${BASE_PATH}/sounds/click.mp3`,
      volume: 1.0,
    },
    {
      name: "noCredits",
      url: `${BASE_PATH}/sounds/noCredits.mp3`,
      volume: 0.3,
    },
    {
      name: "reelStop",
      url: `${BASE_PATH}/sounds/reelStop.mp3`,
      volume: 1.0,
    },
    {
      name: "spinning",
      url: `${BASE_PATH}/sounds/spinning.mp3`,
      volume: 1.0,
    },
    {
      name: "winningLine1",
      url: `${BASE_PATH}/sounds/winningLine-1.mp3`,
      volume: 0.1,
    },
    {
      name: "winningLine2",
      url: `${BASE_PATH}/sounds/winningLine-2.mp3`,
      volume: 0.1,
    },
    {
      name: "winningLine3",
      url: `${BASE_PATH}/sounds/winningLine-3.mp3`,
      volume: 0.1,
    },
    {
      name: "winningLine4",
      url: `${BASE_PATH}/sounds/winningLine-4.mp3`,
      volume: 0.1,
    },
    {
      name: "winningLine5",
      url: `${BASE_PATH}/sounds/winningLine-5.mp3`,
      volume: 0.1,
    },
    {
      name: "winningLine6",
      url: `${BASE_PATH}/sounds/winningLine-6.mp3`,
      volume: 0.1,
    },
    {
      name: "winningLine7",
      url: `${BASE_PATH}/sounds/winningLine-7.mp3`,
      volume: 0.1,
    },
    {
      name: "winningLine8",
      url: `${BASE_PATH}/sounds/winningLine-8.mp3`,
      volume: 0.1,
    },
    {
      name: "winningLine9",
      url: `${BASE_PATH}/sounds/winningLine-9.mp3`,
      volume: 0.1,
    },
    {
      name: "winningLine10",
      url: `${BASE_PATH}/sounds/winningLine-10.mp3`,
      volume: 0.1,
    },
    {
      name: "freeSpinIntro",
      url: `${BASE_PATH}/sounds/freeSpinIntro.mp3`,
      volume: 0.2,
    },
    {
      name: "freeSpinMusic",
      url: `${BASE_PATH}/sounds/freeSpinMusic.mp3`,
      loop: true,
      volume: 0.1,
    },
  ],
};

export const SOUND_NAME = {
  backgroundMusic: "backgroundMusic",
  click: "click",
  spinning: "spinning",
  noCredits: "noCredits",
  reelStop: "reelStop",
  smallWin: "smallWin",
  normalWin: "normalWin",
  mediumWin: "mediumWin",
  bigWin: "bigWin",
  megaWin: "megaWin",
  superWin: "superWin",
  winningLine1: "winningLine1",
  winningLine2: "winningLine2",
  winningLine3: "winningLine3",
  winningLine4: "winningLine4",
  winningLine5: "winningLine5",
  winningLine6: "winningLine6",
  winningLine7: "winningLine7",
  winningLine8: "winningLine8",
  winningLine9: "winningLine9",
  winningLine10: "winningLine10",
  freeSpinIntro: "freeSpinIntro",
  freeSpinMusic: "freeSpinMusic",
};
